import { render } from "./AutocompleteBox.vue?vue&type=template&id=be0dad64&scoped=true"
import script from "./AutocompleteBox.vue?vue&type=script&lang=js"
export * from "./AutocompleteBox.vue?vue&type=script&lang=js"

import "./AutocompleteBox.vue?vue&type=style&index=0&id=be0dad64&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be0dad64"]])

export default __exports__